import { Breadcrumb, Card, Col, Row } from "react-bootstrap";
import Header from "./Header";
import { ReactComponent as MobileIcon } from "../assets/images/mobile.svg";
import { ReactComponent as DesignIcon } from "../assets/images/web-design.svg";
import { ReactComponent as WebIcon } from "../assets/images/web-coding.svg";
import { motion} from "framer-motion";
import android from "../assets/images/android-app.svg";
import react from "../assets/images/react-picture.svg";
import node from "../assets/images/nodejs-development.svg";
import aws from "../assets/images/aws-development.svg";
import Footer from "./Footer";
import "./Services.css";
import { useNavigate } from "react-router-dom";

function Services() {
   const navigate = useNavigate();
  return (
    <>
      <div className="services">
        <div style={{ height: "130px" }}>
          <Header />
        </div>
        <div className="banner text-center">
          <h2>Services</h2>
          <p className="banner-text">
            At Flora Infotech, we turn ideas into powerful digital solutions.
            Our expert team <br /> is dedicated to helping businesses grow
            through modern, scalable, and user-focused technology.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Breadcrumb style={{ color: "white" }} className="text-center mt-3">
              <Breadcrumb.Item className="item" onClick={()=>{navigate('/')}}>Home</Breadcrumb.Item>
              <Breadcrumb.Item className="item" href="" active>
                Services
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
        <div className="container margin-top">
          <Row className="card-div">
            {[1, 2, 3].map((item, i) => (
              <Col lg={4} md={6} sm={12} key={i} className="mb-5">
                <motion.div
                  custom={i}
                  initial="hidden"
                  // animate={servicesInView ? "visible" : "hidden"}
                  // variants={cardVariant}
                >
                  <Card className={`card service-card card${item}`}>
                    <Card.Body>
                      <div className={`card-${item}img`}>
                        {item === 1 && (
                          <WebIcon
                            style={{
                              height: "50px",
                              fill: "#4DAEDE",
                              stroke: "#4DAEDE",
                              strokeWidth: 1,
                              zIndex: 1,
                            }}
                          />
                        )}
                        {item === 2 && (
                          <MobileIcon
                            style={{
                              height: "50px",
                              fill: "#ff930e",
                              stroke: "#ff930e",
                              strokeWidth: 1,
                              zIndex: 1,
                            }}
                          />
                        )}
                        {item === 3 && (
                          <DesignIcon
                            style={{
                              height: "50px",
                              fill: "green",
                              stroke: "green",
                              strokeWidth: 7,
                              zIndex: 1,
                            }}
                          />
                        )}
                      </div>
                      <h4 className="fw-bold mt-3">
                        {item === 1 && "Web Development"}
                        {item === 2 && "Mobile App Development"}
                        {item === 3 && "Web Design"}
                      </h4>
                      <p>
                        {item === 1 &&
                          "We build fast, secure, and scalable websites tailored to your business needs. From responsive layouts to dynamic functionality, our development ensures performance across all devices."}
                        {item === 2 &&
                          "From idea to launch, we develop powerful mobile apps for iOS and Android. Our apps are feature-rich, user-centric, and built for performance and scalability."}
                        {item === 3 &&
                          "Our creative team crafts modern, user-friendly designs that capture attention and enhance user experience. We focus on clean aesthetics, intuitive navigation, and responsive layouts."}
                      </p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>
        <div className="container mb-5 margin-top">
          <Row className="d-flex justify-content-between align-items-center service ">
            <Col lg={6} md={6} sm={12}>
              <h3 className="fw-bold">Android App Development Services</h3>
              <p>
                Reach a wider audience with custom Android apps built for
                performance and usability. We develop robust, feature-rich, and
                visually engaging mobile apps tailored to your business goals.
                From idea to deployment on the Play Store, we offer end-to-end
                Android development using the latest tools and frameworks.
              </p>
            </Col>
            <Col lg={6} md={6} sm={12} className="service-img1">
              <img src={android} className="android-img "  alt="" style={{ height: "350px" }} />
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5 second-col service-img">
              <img src={react}  className="react-img" alt="" style={{ height: "350px" }} />
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5">
              <h3 className="fw-bold"> React js Development Services</h3>
              <p>
                Build fast, responsive, and scalable user interfaces with our
                expert React.js development services. We create dynamic web
                applications with reusable components, seamless performance, and
                intuitive user experiences. Whether it’s a single-page app or a
                large-scale platform, we deliver clean, maintainable, and modern
                front-end solutions tailored to your business needs.
              </p>
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5 second-col">
              <h3 className="fw-bold">Node js Development Services</h3>
              <p>
                Power your backend with the speed and efficiency of Node.js. Our
                team specializes in building real-time, high-performance
                server-side applications that are scalable and secure. From
                RESTful APIs to full-stack applications, we leverage Node.js to
                deliver fast and reliable backend architectures that support
                your web or mobile applications.
              </p>
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5 service-img1" >
              <img src={node} className="node-img" alt="" style={{ height: "350px" }} />
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5 second-col service-img">
              <img src={aws} className="aws-img" alt="" style={{ height: "300px" }} />
            </Col>
            <Col lg={6} md={6} sm={12} className="mt-5">
              <h3 className="fw-bold"> AWS Cloud Services</h3>
              <p>
                Leverage the power of the cloud with our AWS services. We help
                you migrate, manage, and optimize your applications on Amazon
                Web Services. From setting up scalable infrastructure to
                implementing CI/CD pipelines, serverless computing, and data
                storage solutions — our AWS-certified experts ensure
                performance, security, and cost efficiency.
              </p>
            </Col>
          </Row>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Services;
